import { render } from "./PhaseTreatmentDialog.vue?vue&type=template&id=318c5c48&ts=true"
import script from "./PhaseTreatmentDialog.vue?vue&type=script&lang=ts"
export * from "./PhaseTreatmentDialog.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__